// @flow
import React from 'react';

export const ABTestContext = React.createContext<{ [string]: string }>({});
